<template>
    <div class="slider-control is-clearfix">
        <div ref="slider"></div>
        <div class="slider-output">
            <div class="is-pulled-left" ref="event_start" id="event-start"></div>
            <div class="is-pulled-right" ref="event_end" id="event-end"></div>
        </div>
    </div>
</template>

<style lang="scss" rel="stylesheet/scss">
    @import "~nouislider/distribute/nouislider.min.css";

    .slider-output {
        padding: 1rem 0 2rem;
    }

    .noUi-connect {
        background: #F15A5C;
    }
</style>

<script>
    import noUiSlider from "nouislider"
    import wNumb from "wnumb"
    export default {
        name: 'slider-control',
        props: ['start', 'end', 'min', 'max', 'step', 'updateDisplay'],
        mounted () {
            let slider = this.$refs.slider

            let start = parseInt(this.start)
            let end   = parseInt(this.end)

            noUiSlider.create(slider, {
                range: {
                    min: this.min,
                    max: this.max,
                },
                connect: this.end ? [false, true, false] : [true, false],
                step: this.step,
                start: end ? [start, end] : start,
                // No decimals
                format: wNumb({decimals: 0})
            });

            let dateValues = [this.$refs.event_start, this.$refs.event_end];

            slider.noUiSlider.on('update', (values, handle) => {
                dateValues[handle].innerHTML = typeof this.updateDisplay !== 'undefined'
                    ? this.updateDisplay(values[handle]) : values[handle];
            });

            slider.noUiSlider.on('set', (values, handle) => {
                if (handle === 0) {
                    this.$emit('start', values[handle])
                } else if (handle === 1) {
                    this.$emit('end', values[handle])
                }
            });
        },
        data() {
            return {}
        },
    };
</script>



// WEBPACK FOOTER //
// SliderControl.vue?3e82a537